import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from "./URLCatalog";

export class MetabaseService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async getToken(questionCode: string, resourceType: 'question' | 'dashboard' = 'question') {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Metabase.getToken, { questionCode, type: resourceType });
        request.method = "GET";
        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getOrganizationReports(orgId: string) {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Metabase.getOrganizationReports, { org_id: orgId });
        request.method = "GET";
        const response = await this.httpClient.execute(request);
        return response.result;
    }
}
